import React, { useState, useEffect } from 'react';

import EthereumAddressTextField from '../component/EthereumAddressTextField';
import FieldSetFormControl from '../component/FieldSetFormControl';
import HashTextField from '../component/HashTextField';
import HexStringTextField from '../component/HexStringTextField';
import MultilineTextField from '../component/MultilineTextField';

import Box from "@material-ui/core/Box";
import Divider from "@material-ui/core/Divider";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";

import { ethers } from 'ethers';

function RecoverAddress (props) {
  const {
    ...other
  } = props;

  const [ messageVariant, setMessageVariant ] = useState ('text');
  const [ message, setMessage ] = useState ('');
  const [ hash, setHash ] = useState ('');
  const [ signature, setSignature ] = useState ('');
  const [ compressedPublicKey, setCompressedPublicKey ] = useState ('');
  const [ uncompressedPublicKey, setUncompressedPublicKey ] = useState ('');
  const [ address, setAddress ] = useState ('');
  const [ error, setError ] = useState (undefined);

  useEffect (() => {
    if (messageVariant === 'text') {
      setHash (
        ethers.utils.keccak256 (
          ethers.utils.toUtf8Bytes (message)));
    } else if (messageVariant === 'hex') {
      try {
        const messageLowerCase = message.trim ().toLowerCase ();
        if (!messageLowerCase.match (/^0x([0-9a-f]{2})*$/))
          throw new Error ('Invalid hex string');
        setHash (
          ethers.utils.keccak256 (messageLowerCase));
      } catch (errpr) {
        setHash ('');
      }
    } else if (messageVariant === 'transaction') {
      try {
        const messageLowerCase = message.trim ().toLowerCase ();
        if (!messageLowerCase.match (/^0x([0-9a-f]{2})*$/))
          throw new Error ('Invalid hex string');
        const transaction = ethers.utils.parseTransaction (
          messageLowerCase);
        setSignature (
          ethers.utils.hexlify (
            ethers.utils.concat ([
              transaction.r,
              transaction.s,
              transaction.v % 2 === 1 ? '0x1b' : '0x1c'
            ])));
        delete transaction.hash;
        delete transaction.from;
        delete transaction.v;
        delete transaction.r;
        delete transaction.s;
        setHash (
          ethers.utils.keccak256 (
            ethers.utils.serializeTransaction (transaction)));
      } catch (error) {
        setHash ('');
      }
    }
  }, [ messageVariant, message ]);

  useEffect (() => {
    try {
      const publicKey = ethers.utils.recoverPublicKey (hash.trim (), signature.trim ());
      setCompressedPublicKey (ethers.utils.computePublicKey (publicKey, true));
      setUncompressedPublicKey (ethers.utils.computePublicKey (publicKey, false));
      setAddress (ethers.utils.computeAddress (publicKey));
      setError (undefined);
    } catch (error) {
      setCompressedPublicKey ('');
      setUncompressedPublicKey ('');
      setAddress ('');
      setError (error.message);
    }
  }, [ hash, signature ]);

  return (
    <Box my={-1}
         component={FieldSetFormControl}
         fullWidth
         {...other}>
      <Box component={RadioGroup}
           row
           value={messageVariant}
           onChange={event => setMessageVariant (event.target.value)}>
        <FormControlLabel label="Text"
                          control={<Radio />}
                          value="text" />
        <FormControlLabel label="Hex"
                          control={<Radio />}
                          value="hex" />
        <FormControlLabel label="Transaction"
                          control={<Radio />}
                          value="transaction" />
        <FormControlLabel label="Hash"
                          control={<Radio />}
                          value="hash" />
      </Box>
      <Box my={1}
           component={MultilineTextField}
           label="Message"
           disabled={messageVariant === 'hash'}
           placeholder={
             messageVariant === 'text' ? 'Hello, World!' :
             messageVariant === 'hex' || messageVariant === 'transaction' ? '0x0000...' :
             undefined
           }
           validator={
             value => {
               if (messageVariant === 'hex' || messageVariant === 'transaction') {
                 const valueLowerCase = value.trim ().toLowerCase ();
                 if (valueLowerCase === '') return 'Enter valid hex string, please';
                 else if (!valueLowerCase.match (/^0x([0-9a-f]{2})*$/)) return 'Invalid hex string';
                 else if (messageVariant === 'transaction') {
                   try {
                     if (!ethers.utils.parseTransaction (valueLowerCase).hash)
                       throw new Error ('Transaction is not signed');
                     return undefined;
                   } catch (error) {
                     return error.message;
                   }
                 } else return undefined;
               }
             }
           }
           value={message}
           onChange={event => setMessage (event.target.value)} />
      <Box my={1}
           component={HashTextField}
           label="Hash"
           readOnly={messageVariant !== 'hash'}
           value={hash}
           onChange={event => setHash (event.target.value)} />
      <Box my={1}
           component={HexStringTextField}
           label="Signature"
           rows={2}
           readOnly={messageVariant === 'transaction'}
           validator={value => error}
           value={signature}
           onChange={event => setSignature (event.target.value)} />
      <Box mt={1}
           mb={3}>
        <Divider />
      </Box>
      <Box my={1}
           component={HexStringTextField}
           label="Public key (compressed)"
           rows={0}
           readOnly
           value={compressedPublicKey} />
      <Box my={1}
           component={HexStringTextField}
           label="Public key (uncompressed)"
           rows={0}
           readOnly
           value={uncompressedPublicKey} />
      <Box my={1}
           component={EthereumAddressTextField}
           label="Address"
           readOnly={true}
           value={address} />
    </Box>
  );
}

export default RecoverAddress;
